module.exports = __webpack_public_path__ + "static/media/clock.a1d3537a.png";